// [flag, name, dial code] — worldwide dial codes
export const COUNTRY_CODES = [
  ["🇦🇪", "United Arab Emirates", "+971"],
  ["🇸🇦", "Saudi Arabia", "+966"],
  ["🇶🇦", "Qatar", "+974"],
  ["🇰🇼", "Kuwait", "+965"],
  ["🇧🇭", "Bahrain", "+973"],
  ["🇴🇲", "Oman", "+968"],
  ["🇾🇪", "Yemen", "+967"],
  ["🇯🇴", "Jordan", "+962"],
  ["🇱🇧", "Lebanon", "+961"],
  ["🇮🇶", "Iraq", "+964"],
  ["🇸🇾", "Syria", "+963"],
  ["🇵🇸", "Palestine", "+970"],
  ["🇪🇬", "Egypt", "+20"],
  ["🇸🇩", "Sudan", "+249"],
  ["🇱🇾", "Libya", "+218"],
  ["🇹🇳", "Tunisia", "+216"],
  ["🇩🇿", "Algeria", "+213"],
  ["🇲🇦", "Morocco", "+212"],
  ["🇲🇷", "Mauritania", "+222"],
  ["🇸🇴", "Somalia", "+252"],
  ["🇩🇯", "Djibouti", "+253"],
  ["🇰🇲", "Comoros", "+269"],
  ["🇺🇸", "United States", "+1"],
  ["🇨🇦", "Canada", "+1"],
  ["🇬🇧", "United Kingdom", "+44"],
  ["🇮🇪", "Ireland", "+353"],
  ["🇫🇷", "France", "+33"],
  ["🇩🇪", "Germany", "+49"],
  ["🇮🇹", "Italy", "+39"],
  ["🇪🇸", "Spain", "+34"],
  ["🇵🇹", "Portugal", "+351"],
  ["🇳🇱", "Netherlands", "+31"],
  ["🇧🇪", "Belgium", "+32"],
  ["🇱🇺", "Luxembourg", "+352"],
  ["🇨🇭", "Switzerland", "+41"],
  ["🇦🇹", "Austria", "+43"],
  ["🇸🇪", "Sweden", "+46"],
  ["🇳🇴", "Norway", "+47"],
  ["🇩🇰", "Denmark", "+45"],
  ["🇫🇮", "Finland", "+358"],
  ["🇮🇸", "Iceland", "+354"],
  ["🇵🇱", "Poland", "+48"],
  ["🇨🇿", "Czechia", "+420"],
  ["🇸🇰", "Slovakia", "+421"],
  ["🇭🇺", "Hungary", "+36"],
  ["🇷🇴", "Romania", "+40"],
  ["🇧🇬", "Bulgaria", "+359"],
  ["🇬🇷", "Greece", "+30"],
  ["🇭🇷", "Croatia", "+385"],
  ["🇷🇸", "Serbia", "+381"],
  ["🇸🇮", "Slovenia", "+386"],
  ["🇧🇦", "Bosnia & Herzegovina", "+387"],
  ["🇦🇱", "Albania", "+355"],
  ["🇲🇰", "North Macedonia", "+389"],
  ["🇺🇦", "Ukraine", "+380"],
  ["🇧🇾", "Belarus", "+375"],
  ["🇷🇺", "Russia", "+7"],
  ["🇰🇿", "Kazakhstan", "+7"],
  ["🇹🇷", "Türkiye", "+90"],
  ["🇨🇾", "Cyprus", "+357"],
  ["🇲🇹", "Malta", "+356"],
  ["🇪🇪", "Estonia", "+372"],
  ["🇱🇻", "Latvia", "+371"],
  ["🇱🇹", "Lithuania", "+370"],
  ["🇬🇪", "Georgia", "+995"],
  ["🇦🇲", "Armenia", "+374"],
  ["🇦🇿", "Azerbaijan", "+994"],
  ["🇮🇷", "Iran", "+98"],
  ["🇮🇱", "Israel", "+972"],
  ["🇵🇰", "Pakistan", "+92"],
  ["🇮🇳", "India", "+91"],
  ["🇧🇩", "Bangladesh", "+880"],
  ["🇱🇰", "Sri Lanka", "+94"],
  ["🇳🇵", "Nepal", "+977"],
  ["🇦🇫", "Afghanistan", "+93"],
  ["🇲🇻", "Maldives", "+960"],
  ["🇨🇳", "China", "+86"],
  ["🇭🇰", "Hong Kong", "+852"],
  ["🇹🇼", "Taiwan", "+886"],
  ["🇯🇵", "Japan", "+81"],
  ["🇰🇷", "South Korea", "+82"],
  ["🇸🇬", "Singapore", "+65"],
  ["🇲🇾", "Malaysia", "+60"],
  ["🇮🇩", "Indonesia", "+62"],
  ["🇹🇭", "Thailand", "+66"],
  ["🇻🇳", "Vietnam", "+84"],
  ["🇵🇭", "Philippines", "+63"],
  ["🇰🇭", "Cambodia", "+855"],
  ["🇱🇦", "Laos", "+856"],
  ["🇲🇲", "Myanmar", "+95"],
  ["🇧🇳", "Brunei", "+673"],
  ["🇦🇺", "Australia", "+61"],
  ["🇳🇿", "New Zealand", "+64"],
  ["🇫🇯", "Fiji", "+679"],
  ["🇿🇦", "South Africa", "+27"],
  ["🇳🇬", "Nigeria", "+234"],
  ["🇬🇭", "Ghana", "+233"],
  ["🇰🇪", "Kenya", "+254"],
  ["🇹🇿", "Tanzania", "+255"],
  ["🇺🇬", "Uganda", "+256"],
  ["🇪🇹", "Ethiopia", "+251"],
  ["🇨🇲", "Cameroon", "+237"],
  ["🇨🇮", "Côte d'Ivoire", "+225"],
  ["🇸🇳", "Senegal", "+221"],
  ["🇦🇴", "Angola", "+244"],
  ["🇿🇲", "Zambia", "+260"],
  ["🇿🇼", "Zimbabwe", "+263"],
  ["🇧🇼", "Botswana", "+267"],
  ["🇳🇦", "Namibia", "+264"],
  ["🇲🇺", "Mauritius", "+230"],
  ["🇷🇼", "Rwanda", "+250"],
  ["🇲🇿", "Mozambique", "+258"],
  ["🇧🇷", "Brazil", "+55"],
  ["🇦🇷", "Argentina", "+54"],
  ["🇨🇱", "Chile", "+56"],
  ["🇨🇴", "Colombia", "+57"],
  ["🇵🇪", "Peru", "+51"],
  ["🇻🇪", "Venezuela", "+58"],
  ["🇪🇨", "Ecuador", "+593"],
  ["🇧🇴", "Bolivia", "+591"],
  ["🇵🇾", "Paraguay", "+595"],
  ["🇺🇾", "Uruguay", "+598"],
  ["🇲🇽", "Mexico", "+52"],
  ["🇬🇹", "Guatemala", "+502"],
  ["🇨🇷", "Costa Rica", "+506"],
  ["🇵🇦", "Panama", "+507"],
  ["🇩🇴", "Dominican Republic", "+1"],
  ["🇯🇲", "Jamaica", "+1"],
  ["🇹🇹", "Trinidad & Tobago", "+1"],
  ["🇵🇷", "Puerto Rico", "+1"],
];
